// File: EVOLVE/Projects/cristTools/client/src/components/FinancialDashboard.js
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import FinancialSummary from './financial/FinancialSummary';
import FinancialPlanner from './financial/FinancialPlanner';
import FinancialForecast from './financial/FinancialForecast';
import InvestmentDashboard from './financial/InvestmentDashboard';
import AccountsManager from './financial/AccountsManager';

const FinancialDashboard = () => {
  const [activeTab, setActiveTab] = useState('summary');
  const user = useSelector((state) => state.auth.user);

  return (
    <div className="min-h-screen bg-gray-100">
      <header className="bg-white shadow">
        <div className="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
          <h1 className="text-3xl font-bold text-gray-900">Financial Dashboard</h1>
        </div>
      </header>

      <main className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
        <div className="px-4 py-6 sm:px-0">
          {/* User Info Card */}
          <div className="bg-white overflow-hidden shadow rounded-lg divide-y divide-gray-200 mb-6">
            <div className="px-4 py-5 sm:p-6">
              <h2 className="text-lg leading-6 font-medium text-gray-900">Financial Overview</h2>
              <div className="mt-3 sm:mt-5">
                <p className="text-sm text-gray-500">Account Holder</p>
                <p className="mt-1 text-xl font-semibold text-gray-900">{user?.displayName || 'User'}</p>
              </div>
            </div>
          </div>

          {/* Navigation Tabs */}
          <div className="bg-white overflow-hidden shadow rounded-lg">
            <div className="border-b border-gray-200">
              <nav className="-mb-px flex">
                {['Summary', 'Planner', 'Forecast', 'Investments', 'Accounts'].map((tab) => (
                  <button
                    key={tab.toLowerCase()}
                    onClick={() => setActiveTab(tab.toLowerCase())}
                    className={`${
                      activeTab === tab.toLowerCase()
                        ? 'border-indigo-500 text-indigo-600'
                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                    } whitespace-nowrap py-4 px-6 border-b-2 font-medium text-sm`}
                  >
                    {tab}
                  </button>
                ))}
              </nav>
            </div>

            <div className="px-4 py-5 sm:p-6">
              {activeTab === 'summary' && <FinancialSummary />}
              {activeTab === 'planner' && <FinancialPlanner />}
              {activeTab === 'forecast' && <FinancialForecast />}
              {activeTab === 'investments' && <InvestmentDashboard />}
              {activeTab === 'accounts' && <AccountsManager />}
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default FinancialDashboard;